module.exports = __webpack_public_path__ + "img/logo.08b45b0a.png";